import { LinkPlugin as LexicalLinkPlugin } from "@lexical/react/LexicalLinkPlugin";

import { URL_MATCHER } from "./AutoLinkPlugin";

export const LinkPlugin = () => {
  return (
    <LexicalLinkPlugin
      validateUrl={(url) => url === "https://" || URL_MATCHER.test(url)}
    />
  );
};
